module.exports = __webpack_public_path__ + "static/img/dataTop.d54aaf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/dataTop.jpg
// module id = F6FT
// module chunks = 0